module.exports = __webpack_public_path__ + "static/img/yeswecan0031.8ef8630.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0031.png
// module id = 597
// module chunks = 1